import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlert2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 13.0127C10.1907 13.0127 10.3506 12.9483 10.4796 12.8194C10.6086 12.6904 10.6731 12.5305 10.6731 12.3398C10.6731 12.1491 10.6086 11.9892 10.4796 11.8602C10.3506 11.7312 10.1907 11.6667 10 11.6667C9.80931 11.6667 9.64944 11.7312 9.52042 11.8602C9.39139 11.9892 9.32688 12.1491 9.32688 12.3398C9.32688 12.5305 9.39139 12.6904 9.52042 12.8194C9.64944 12.9483 9.80931 13.0127 10 13.0127ZM9.375 10.1763H10.625V6.15396H9.375V10.1763ZM10 17.9006C8.19764 17.4091 6.70542 16.3482 5.52333 14.7179C4.34111 13.0876 3.75 11.265 3.75 9.25V4.45521L10 2.11542L16.25 4.45521V9.25C16.25 11.265 15.6589 13.0876 14.4767 14.7179C13.2946 16.3482 11.8024 17.4091 10 17.9006ZM10 16.5833C11.4444 16.125 12.6389 15.2083 13.5833 13.8333C14.5278 12.4583 15 10.9306 15 9.25V5.3125L10 3.44542L5 5.3125V9.25C5 10.9306 5.47222 12.4583 6.41667 13.8333C7.36111 15.2083 8.55556 16.125 10 16.5833Z",
		fill: "currentColor"
	})
});
export default SvgAlert2;
